import * as angular from "angular";

declare let gtag: any;

function GTagProvider(): any {

  this.init = (tagId) => {

    window['dataLayer'] = window['dataLayer'] || [];
    window['dataLayer'].push({
      'gtm.start':
        new Date().getTime(), event: 'gtm.js'
    });

    const script1 = document.createElement('script');
    script1.setAttribute('async', 'true');
    script1.setAttribute('src', 'https://www.googletagmanager.com/gtm.js?id=' + tagId);

    document.head.appendChild(script1);

    window['gtag'] = function (){
      window['dataLayer'].push(arguments);
    }

    gtag('js', new Date());
    gtag('config', tagId);
  };

  this.$get = () => {
    return {
      init: this.init
    };
  };
}

angular
  .module('bringoz.admin')
  .provider('GTag', GTagProvider);
